import React, { createContext, useContext, useState, useEffect, useCallback } from "react";

const dict = {
  en: {
    app_name: "Financial Advisor",
    tagline: "Save Daily, Secure Future",
    login: "Login",
    register: "Register",
    welcome: "Welcome",
    customer_login: "Customer Login",
    agent_login: "Agent Login",
    admin_login: "Admin Login",
    super_admin_login: "Super Admin",
    send_otp: "Send OTP",
    verify_otp: "Verify OTP",
    phone_placeholder: "Enter Mobile Number",
    otp_placeholder: "Enter 6-digit OTP",
    home: "Home",
    wallet: "Wallet",
    benefits: "Benefits",
    policies: "Policies",
    profile: "Profile",
    saving_wallet: "Saving Wallet",
    bonus_wallet: "Bonus Wallet",
    total_savings: "Total Savings",
    available_balance: "Available Balance",
    add_money: "Add Money",
    withdraw: "Withdraw",
    transfer: "Transfer",
    history: "History",
    daily_collection: "Daily Collection",
    pay_premium: "Pay Premium",
    policy_details: "Policy Details",
    referral: "Referral",
    lucky_draw: "Lucky Draw",
    finance_support: "Finance Support",
    notifications: "Notifications",
    quick_actions: "Quick Actions",
    hello: "Hello",
    logout: "Logout",
    save_daily: "Save Daily",
    secure_future: "Secure Future",
    build_wealth: "Build Wealth",
    protect_family: "Protect Family",
    submit: "Submit",
    cancel: "Cancel",
    save: "Save",
    approve: "Approve",
    reject: "Reject",
    pending: "Pending",
    approved: "Approved",
    rejected: "Rejected",
    active: "Active",
    suspended: "Suspended",
    full_name: "Full Name",
    mobile_number: "Mobile Number",
    aadhaar: "Aadhaar Number",
    pan: "PAN Number",
    address: "Address",
    nominee: "Nominee Name",
    dashboard: "Dashboard",
    customers: "Customers",
    agents: "Agents",
    withdrawals: "Withdrawals",
    reports: "Reports",
    settings: "Settings",
    tenants: "Tenants",
    transactions: "Transactions",
    enter_amount: "Enter Amount",
    completed: "Completed",
    welcome_back: "Welcome Back",
    login_subtitle: "Login to your account using mobile + OTP",
    customer: "Customer",
    agent: "Agent",
    admin: "Admin",
    change_number: "Change number",
    enter_otp: "Enter OTP",
    sending: "Sending...",
    verifying: "Verifying...",
    otp_sent_to: "OTP sent to",
    demo_accounts: "Demo Accounts",
    super_admin: "Super Admin",
    demo_tenant: "Demo Tenant",
    demo_agent: "Demo Agent",
    demo_customer: "Demo Customer",
    no_account: "Don't have an account?",
    // Registration / referral / T&C
    almost_there: "Almost there!",
    almost_there_desc: "Tell us your name and we'll remember it next time.",
    enter_full_name: "Enter your full name",
    i_have_referral: "I have a Referral Code",
    enter_referral_code: "Enter referral code",
    referral_locked_msg: "Auto-filled from your referral link — cannot be changed.",
    i_agree_to: "I agree to the",
    terms_conditions: "Terms & Conditions",
    privacy_policy: "Privacy Policy",
    creating_account: "Creating account...",
    create_account_btn: "Create my account",
    back: "Back",
    resend_otp: "Resend OTP",
    resend_in: "Resend in",
    logging_into: "Logging into",
    // Referral page
    refer_and_earn: "Refer & Earn",
    your_referral_code: "Your Referral Code",
    copy_code: "Copy Code",
    share_link_btn: "Share Link",
    your_invite_link: "Your invite link",
    total: "Total",
    earned: "Earned",
    pending_label: "Pending",
    how_it_works: "How it works",
    how_step_1: "Share your code or invite link with friends & family",
    how_step_2: "Friend signs up using your code or link",
    how_step_3: "Friend completes their first premium payment",
    how_step_4_prefix: "You earn",
    how_step_4_suffix: "in Bonus Wallet (after admin approval)",
    recent_referrals: "Recent Referrals",
    no_referrals_yet: "No referrals yet — share now to earn",
    paid: "Paid",
    awaiting_admin: "Awaiting admin",
    waiting_first_payment: "Waiting first payment",
    code_copied: "Code copied!",
    link_copied: "Link copied!",
    copy_failed: "Copy failed",
  },
  te: {
    app_name: "ఫైనాన్షియల్ అడ్వైజర్",
    tagline: "రోజూ ఆదా చేయండి, భవిష్యత్తును భద్రపరచండి",
    login: "లాగిన్",
    register: "నమోదు",
    welcome: "స్వాగతం",
    customer_login: "కస్టమర్ లాగిన్",
    agent_login: "ఏజెంట్ లాగిన్",
    admin_login: "అడ్మిన్ లాగిన్",
    super_admin_login: "సూపర్ అడ్మిన్",
    send_otp: "OTP పంపండి",
    verify_otp: "OTP ధృవీకరించండి",
    phone_placeholder: "మొబైల్ నంబర్ నమోదు చేయండి",
    otp_placeholder: "6-అంకెల OTP నమోదు చేయండి",
    home: "హోమ్",
    wallet: "వాలెట్",
    benefits: "ప్రయోజనాలు",
    policies: "పాలసీలు",
    profile: "ప్రొఫైల్",
    saving_wallet: "సేవింగ్ వాలెట్",
    bonus_wallet: "బోనస్ వాలెట్",
    total_savings: "మొత్తం పొదుపు",
    available_balance: "అందుబాటులో ఉన్న బ్యాలెన్స్",
    add_money: "డబ్బు జోడించండి",
    withdraw: "విత్‌డ్రా",
    transfer: "బదిలీ",
    history: "చరిత్ర",
    daily_collection: "రోజువారీ సేకరణ",
    pay_premium: "ప్రీమియం చెల్లించండి",
    policy_details: "పాలసీ వివరాలు",
    referral: "రెఫరల్",
    lucky_draw: "లక్కీ డ్రా",
    finance_support: "ఫైనాన్స్ సపోర్ట్",
    notifications: "నోటిఫికేషన్లు",
    quick_actions: "త్వరిత చర్యలు",
    hello: "నమస్కారం",
    logout: "లాగౌట్",
    save_daily: "రోజూ పొదుపు",
    secure_future: "సురక్షిత భవిష్యత్తు",
    build_wealth: "సంపద నిర్మాణం",
    protect_family: "కుటుంబ రక్షణ",
    submit: "సమర్పించండి",
    cancel: "రద్దు",
    save: "సేవ్",
    approve: "ఆమోదించండి",
    reject: "తిరస్కరించండి",
    pending: "పెండింగ్",
    approved: "ఆమోదించబడింది",
    rejected: "తిరస్కరించబడింది",
    active: "క్రియాశీలం",
    suspended: "నిలిపివేయబడింది",
    full_name: "పూర్తి పేరు",
    mobile_number: "మొబైల్ నంబర్",
    aadhaar: "ఆధార్ నంబర్",
    pan: "PAN నంబర్",
    address: "చిరునామా",
    nominee: "నామినీ పేరు",
    dashboard: "డ్యాష్‌బోర్డ్",
    customers: "కస్టమర్లు",
    agents: "ఏజెంట్లు",
    withdrawals: "విత్‌డ్రాలు",
    reports: "నివేదికలు",
    settings: "సెట్టింగ్‌లు",
    tenants: "టెనెంట్‌లు",
    transactions: "లావాదేవీలు",
    enter_amount: "మొత్తం నమోదు చేయండి",
    completed: "పూర్తయింది",
    welcome_back: "తిరిగి స్వాగతం",
    login_subtitle: "మొబైల్ + OTP ఉపయోగించి మీ ఖాతాకు లాగిన్ అవ్వండి",
    customer: "కస్టమర్",
    agent: "ఏజెంట్",
    admin: "అడ్మిన్",
    change_number: "నంబర్ మార్చండి",
    enter_otp: "OTP నమోదు చేయండి",
    sending: "పంపుతోంది...",
    verifying: "ధృవీకరిస్తోంది...",
    otp_sent_to: "OTP పంపబడింది",
    demo_accounts: "డెమో ఖాతాలు",
    super_admin: "సూపర్ అడ్మిన్",
    demo_tenant: "డెమో టెనెంట్",
    demo_agent: "డెమో ఏజెంట్",
    demo_customer: "డెమో కస్టమర్",
    no_account: "ఖాతా లేదా?",
    // Registration / referral / T&C
    almost_there: "ఇంకొక్క అడుగు!",
    almost_there_desc: "మీ పేరు చెప్పండి — తదుపరిసారి మేము గుర్తుంచుకుంటాం.",
    enter_full_name: "మీ పూర్తి పేరును నమోదు చేయండి",
    i_have_referral: "నా దగ్గర రెఫరల్ కోడ్ ఉంది",
    enter_referral_code: "రెఫరల్ కోడ్ నమోదు చేయండి",
    referral_locked_msg: "మీ రెఫరల్ లింక్ నుండి స్వయంగా నింపబడింది — మార్చలేరు.",
    i_agree_to: "నేను అంగీకరిస్తున్నాను",
    terms_conditions: "నిబంధనలు & షరతులు",
    privacy_policy: "గోప్యతా విధానం",
    creating_account: "ఖాతా సృష్టిస్తోంది...",
    create_account_btn: "నా ఖాతా సృష్టించండి",
    back: "వెనుకకు",
    resend_otp: "OTP మళ్లీ పంపండి",
    resend_in: "మళ్లీ పంపండి",
    logging_into: "లాగిన్ అవుతోంది",
    // Referral page
    refer_and_earn: "రెఫర్ చేసి సంపాదించండి",
    your_referral_code: "మీ రెఫరల్ కోడ్",
    copy_code: "కోడ్ కాపీ చేయండి",
    share_link_btn: "లింక్ షేర్ చేయండి",
    your_invite_link: "మీ ఆహ్వాన లింక్",
    total: "మొత్తం",
    earned: "సంపాదించారు",
    pending_label: "పెండింగ్",
    how_it_works: "ఇది ఎలా పనిచేస్తుంది",
    how_step_1: "మీ కోడ్ లేదా ఆహ్వాన లింక్‌ను స్నేహితులు & కుటుంబ సభ్యులతో పంచుకోండి",
    how_step_2: "స్నేహితుడు మీ కోడ్ లేదా లింక్ ఉపయోగించి సైన్ అప్ చేస్తారు",
    how_step_3: "స్నేహితుడు తమ మొదటి ప్రీమియం చెల్లింపును పూర్తి చేస్తారు",
    how_step_4_prefix: "మీరు సంపాదిస్తారు",
    how_step_4_suffix: "బోనస్ వాలెట్‌లో (అడ్మిన్ ఆమోదం తర్వాత)",
    recent_referrals: "ఇటీవలి రెఫరల్స్",
    no_referrals_yet: "ఇంకా రెఫరల్స్ లేవు — ఇప్పుడే షేర్ చేసి సంపాదించండి",
    paid: "చెల్లించబడింది",
    awaiting_admin: "అడ్మిన్ కోసం వేచి ఉంది",
    waiting_first_payment: "మొదటి చెల్లింపు కోసం వేచి ఉంది",
    code_copied: "కోడ్ కాపీ చేయబడింది!",
    link_copied: "లింక్ కాపీ చేయబడింది!",
    copy_failed: "కాపీ విఫలమైంది",
  },
};

const I18nContext = createContext({ lang: "en", t: (k) => k, setLang: () => {} });

export const I18nProvider = ({ children }) => {
  const [lang, setLangState] = useState(() => localStorage.getItem("fa_lang") || "en");
  useEffect(() => { localStorage.setItem("fa_lang", lang); }, [lang]);
  const setLang = useCallback((l) => setLangState(l), []);
  const t = useCallback((key) => dict[lang]?.[key] ?? dict.en[key] ?? key, [lang]);
  return <I18nContext.Provider value={{ lang, t, setLang }}>{children}</I18nContext.Provider>;
};

export const useI18n = () => useContext(I18nContext);
